import React from 'react';

export interface Image {
  title: string;
  imageType?: string;
  transforms: Record<string, {
    url: string;
    width: string;
    height: string;
  }>;
}

interface PictureProps {
  image: Image;
  defaultTransform: string;
  // alt?: string | null,
  loading: 'lazy' | 'eager';
}

export default function Picture({
  image,
  defaultTransform,
  // alt = undefined,
  loading,
}: PictureProps) {
  const media = {
    all: '',
    xxs: '(max-width: 412px)',
    xs: '(max-width: 575px)',
    sm: '(max-width: 767px)',
    'md-min': '(max-width: 768px)',
    md: '(max-width: 1024px)',
    'lg-min': '(min-width: 1025px)',
    lg: '(max-width: 1439px)',
    xl: '(max-width: 1679px)',
    'xxl-min': '(min-width: 1680px)',
    xxl: '(max-width: 1879px)',
    '4k': '(min-width: 3840px)',
    xxxl: '(min-width: 1880px)',
  };

  return (
    image && (
      <picture>
        {Object.entries(media).map(([key, value]) => (
          (image.transforms[key]) && (
            <source
              media={value}
              srcSet={image.transforms[key]?.url}
              key={key}
              width={image.transforms[key]?.width}
              height={image.transforms[key]?.height}
            />
          )
        ))}
        <img
          src={image.transforms[defaultTransform]?.url}
          alt={image.title || ''}
          loading={loading}
          width={image.transforms[defaultTransform]?.width}
          height={image.transforms[defaultTransform]?.height}
        />
      </picture>
    )
  );
}
